/**
 * OutreachOS wordmark.
 *
 * Two variants:
 *  - "white"  → for dark backgrounds (default - the entire app is dark)
 *  - "black"  → for light backgrounds (PDF reports, light marketing slices, etc.)
 */
export default function Logo({ variant = "white", className = "h-7" }) {
  const src =
    variant === "black"
      ? "https://customer-assets.emergentagent.com/job_outreach-gmail-sync/artifacts/w10ciiw1_outreach-os-logo-black-transparent.png"
      : "https://customer-assets.emergentagent.com/job_outreach-gmail-sync/artifacts/wk6aupfa_outreach-os-logo-white-transparent.png";
  return (
    <img
      src={src}
      alt="OutreachOS"
      className={className}
      draggable={false}
      data-testid={`logo-${variant}`}
    />
  );
}
